import { Injectable } from '@angular/core';
import { CognitoUser } from 'amazon-cognito-identity-js';

@Injectable({
  providedIn: 'root'
})
export class RouteStateService {
  private fromForgotPassword = false;
  private cognitoUser: CognitoUser | null = null;
  private redirectUrl: string = '/'; // Default fallback redirect

  constructor() { }

  // Forgot Password flag
  setFromForgotPassword(value: boolean) {
    this.fromForgotPassword = value;
  }

  getFromForgotPassword(): boolean {
    return this.fromForgotPassword;
  }

  // Cognito User
  setCognitoUser(user: CognitoUser) {
    this.cognitoUser = user;
  }

  getCognitoUser(): CognitoUser | null {
    return this.cognitoUser;
  }

  setRedirectUrl(url: string) {
    this.redirectUrl = url;
  }

  getRedirectUrl(): string {
    return this.redirectUrl;
  }

  clearRedirectUrl() {
    this.redirectUrl = '/';
  }
}
